export default {"src":"/_next/static/media/skiing.588278c6.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};